import { Popover, Layout, Menu, Modal, Row, Col, Checkbox, Popconfirm, Button, Card, ConfigProvider, Tabs, Typography, message, Input } from 'antd';
import React, { useEffect, useState, useRef, useContext } from 'react';
import styled from 'styled-components';
import ShareLearningModal from './ShareLearningModal';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { EditOutlined, ArrowRightOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import Label_language from '../../language';
import AdminModal from "./AdminModal";
import TextArea from 'antd/es/input/TextArea';
const { Title, Paragraph, Text, Link } = Typography;
const VideoModal = (props) => {
    return (<>
        <AdminModal
            {...props}
            title={(<>
                <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 50, left: 28 }} >{props.title}</Col>
                <Col>
                    {props.edit ?
                        <>
                            <Popconfirm
                                placement="topRight"
                                title='確定刪除嗎？'
                                onConfirm={e => props.handleDelete(props.editcard['blog_id'])}
                                okText="確定"
                                cancelText="取消"
                            >
                                <Button style={{ backgroundColor: '#FCF5F6' }} >
                                    <Row>
                                        <Col span={6}>
                                            <img width="80%" src='/cram_school/trashicon.png'></img>
                                        </Col>
                                        <Col span={18}>
                                            <span>刪除貼文</span>
                                        </Col>
                                    </Row>
                                </Button>
                            </Popconfirm>
                        </> :
                        <>
                        </>
                    }
                </Col>
            </>)}
            uploads={false}
        >
            <Row gutter={[10, 10]}>
                <Col span={24}>影片嵌入程式碼</Col>
                <Col span={24}>
                    <TextArea rows={10}
                        value={props.editcard.youtube_iframe}
                        placeholder='<iframe width="1280" height="720" 
                        src="https://www.youtube.com/embed/peK_3_vh6gA" title="Not only 教學  but also 把愛傳出去 | 臺灣蒙恩的孩子教育協會 『教學VLOG』" 
                        frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        allowfullscreen></iframe>'
                        onChange={(e) => props.setEditCard((pre) => {
                            return (
                                {
                                    ...pre,
                                    youtube_iframe: e.target.value,
                                }
                            )
                        })}
                    ></TextArea>
                </Col>
                <Col span={6}>影片標題</Col>
                <Col span={18}>
                    <Input value={props.editcard.title}
                        placeholder='請輸入影片標題'
                        onChange={(e) => props.setEditCard((pre) => {
                            return (
                                {
                                    ...pre,
                                    title: e.target.value,
                                }
                            )
                        })}
                    />
                </Col>
                <Col span={6}>影片介紹</Col>
                <Col span={18}>
                    <TextArea rows={3}
                        value={props.editcard.content}
                        placeholder='請輸入影片介紹'
                        onChange={(e) => props.setEditCard((pre) => {
                            return (
                                {
                                    ...pre,
                                    content: e.target.value,
                                }
                            )
                        })}
                    ></TextArea>
                </Col>
            </Row >
        </AdminModal >
    </>)
}
export default VideoModal;